import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f2d7b3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-7 gap-lg-10" }
const _hoisted_2 = { class: "d-flex flex-column flex-xl-row gap-7 gap-lg-10" }
const _hoisted_3 = { class: "card card-flush py-4 flex-1" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "card-body py-0" }
const _hoisted_7 = { class: "table-responsive max-sm-scrollbar-hidden" }
const _hoisted_8 = { class: "table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px" }
const _hoisted_9 = { class: "fw-bold text-gray-800" }
const _hoisted_10 = { class: "text-nowrap text-muted" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "svg-icon svg-icon-2 me-2" }
const _hoisted_13 = { class: "fw-bold text-end" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "text-nowrap text-muted" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "svg-icon svg-icon-2 me-2" }
const _hoisted_18 = { class: "fw-bold text-end" }
const _hoisted_19 = { class: "text-nowrap text-muted" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "svg-icon svg-icon-2 me-2" }
const _hoisted_22 = { class: "fw-bold text-end break-all" }
const _hoisted_23 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_24 = {
  key: 0,
  class: "me-2"
}
const _hoisted_25 = { class: "svg-icon svg-icon-4 svg-icon-gray-600 ms-2" }
const _hoisted_26 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed p-6"
}
const _hoisted_27 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-700 text-line-clamp-2" })
  ])
], -1))
const _hoisted_29 = {
  key: 0,
  class: "card card-flush py-4 flex-1"
}
const _hoisted_30 = { class: "card-header py-5" }
const _hoisted_31 = { class: "card-title align-items-start flex-column" }
const _hoisted_32 = {
  key: 0,
  class: "text-gray-400 mt-1 fw-semibold fs-6"
}
const _hoisted_33 = { class: "card-toolbar" }
const _hoisted_34 = ["title"]
const _hoisted_35 = { class: "card-body py-0" }
const _hoisted_36 = { class: "table-responsive mb-5 max-sm-scrollbar-hidden" }
const _hoisted_37 = { class: "table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px" }
const _hoisted_38 = { class: "fw-bold text-gray-800" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "text-nowrap text-muted" }
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = { class: "svg-icon svg-icon-2 me-2" }
const _hoisted_43 = { class: "fw-bold text-end" }
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = { class: "svg-icon svg-icon-4 svg-icon-gray-600 ms-2" }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "text-nowrap text-muted" }
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = { class: "svg-icon svg-icon-2 me-2" }
const _hoisted_50 = { class: "fw-bold text-end" }
const _hoisted_51 = {
  key: 0,
  class: "svg-icon svg-icon-2 ms-2"
}
const _hoisted_52 = { key: 2 }
const _hoisted_53 = { class: "text-nowrap text-muted" }
const _hoisted_54 = { class: "d-flex align-items-center" }
const _hoisted_55 = { class: "svg-icon svg-icon-2 me-2" }
const _hoisted_56 = { class: "fw-bold text-end" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("(")
const _hoisted_59 = { class: "text-success" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(")")
const _hoisted_61 = { key: 1 }
const _hoisted_62 = /*#__PURE__*/_createTextVNode("(")
const _hoisted_63 = { class: "text-danger" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(")")
const _hoisted_65 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed p-6"
}
const _hoisted_66 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_67 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_68 = { class: "fw-semibold" }
const _hoisted_69 = { class: "fs-6 text-gray-700" }
const _hoisted_70 = { class: "card card-flush py-4 flex-1" }
const _hoisted_71 = { class: "card-header py-5" }
const _hoisted_72 = { class: "card-title align-items-start flex-column" }
const _hoisted_73 = {
  key: 0,
  class: "text-gray-400 mt-1 fw-semibold fs-6"
}
const _hoisted_74 = { class: "card-toolbar" }
const _hoisted_75 = ["title"]
const _hoisted_76 = { class: "card-body py-0" }
const _hoisted_77 = { class: "table-responsive max-sm-scrollbar-hidden" }
const _hoisted_78 = { class: "table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px" }
const _hoisted_79 = { class: "fw-bold text-gray-800" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { class: "text-nowrap text-muted" }
const _hoisted_82 = { class: "d-flex align-items-center" }
const _hoisted_83 = { class: "svg-icon svg-icon-2 me-2" }
const _hoisted_84 = { class: "fw-bold text-end" }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { class: "text-nowrap text-muted" }
const _hoisted_87 = { class: "d-flex align-items-center" }
const _hoisted_88 = { class: "svg-icon svg-icon-2 me-2" }
const _hoisted_89 = { class: "fw-bold text-end" }
const _hoisted_90 = { key: 2 }
const _hoisted_91 = { class: "text-nowrap text-muted" }
const _hoisted_92 = { class: "d-flex align-items-center" }
const _hoisted_93 = { class: "svg-icon svg-icon-2 me-2" }
const _hoisted_94 = ["innerHTML"]
const _hoisted_95 = { key: 3 }
const _hoisted_96 = { class: "text-nowrap text-muted" }
const _hoisted_97 = { class: "d-flex align-items-center" }
const _hoisted_98 = { class: "svg-icon svg-icon-2 me-2" }
const _hoisted_99 = { class: "fw-bold text-end" }
const _hoisted_100 = { key: 4 }
const _hoisted_101 = { class: "text-muted" }
const _hoisted_102 = { class: "d-flex align-items-center" }
const _hoisted_103 = { class: "svg-icon svg-icon-2 me-2" }
const _hoisted_104 = { class: "fw-bold text-end" }
const _hoisted_105 = { class: "svg-icon svg-icon-2 svg-icon-primary me-2" }
const _hoisted_106 = { class: "d-flex flex-column gap-7 gap-lg-10" }
const _hoisted_107 = { class: "d-flex flex-column flex-xl-row gap-7 gap-lg-10" }
const _hoisted_108 = {
  key: 0,
  class: "card flex-1 card-flush py-4 overflow-hidden"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute bottom-0 end-0 opacity-10 pe-none text-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/duotune/ecommerce/ecm001.svg",
    class: "w-150px"
  })
], -1))
const _hoisted_110 = { class: "card-header py-5" }
const _hoisted_111 = { class: "card-title align-items-start flex-column" }
const _hoisted_112 = {
  key: 0,
  class: "text-gray-400 mt-1 fw-semibold fs-6"
}
const _hoisted_113 = { class: "card-toolbar" }
const _hoisted_114 = ["title"]
const _hoisted_115 = { class: "card-body pt-0" }
const _hoisted_116 = { class: "d-flex flex-column flex-xl-row d-grid gap-5" }
const _hoisted_117 = {
  key: 0,
  class: "flex-fill py-xl-0 py-2 border-xl-end"
}
const _hoisted_118 = { class: "m-0 pe-5" }
const _hoisted_119 = { class: "fw-bolder text-gray-800 mb-3" }
const _hoisted_120 = { class: "row" }
const _hoisted_121 = {
  key: 0,
  class: "col-12"
}
const _hoisted_122 = { class: "d-flex align-items-center fs-7 fw-bold text-gray-400" }
const _hoisted_123 = { class: "svg-icon svg-icon-6 svg-icon-gray-600 me-2" }
const _hoisted_124 = {
  key: 1,
  class: "col-12"
}
const _hoisted_125 = { class: "d-flex align-items-center fs-7 fw-bold text-gray-400" }
const _hoisted_126 = { class: "svg-icon svg-icon-6 svg-icon-gray-600 me-2" }
const _hoisted_127 = { class: "text-success" }
const _hoisted_128 = {
  key: 2,
  class: "col-12"
}
const _hoisted_129 = { class: "d-flex align-items-center fs-7 fw-bold text-gray-400" }
const _hoisted_130 = { class: "svg-icon svg-icon-6 svg-icon-gray-600 me-2" }
const _hoisted_131 = { class: "flex-fill py-2" }
const _hoisted_132 = { class: "m-0" }
const _hoisted_133 = { class: "table-responsive max-sm-scrollbar-hidden" }
const _hoisted_134 = { class: "table align-middle table-row-bordered mb-0 fs-6 gy-5" }
const _hoisted_135 = { class: "fw-bold text-gray-800" }
const _hoisted_136 = { key: 0 }
const _hoisted_137 = { class: "text-nowrap text-muted pt-0" }
const _hoisted_138 = { class: "d-flex align-items-center" }
const _hoisted_139 = { class: "fw-bold text-end pt-0" }
const _hoisted_140 = { key: 1 }
const _hoisted_141 = { class: "text-nowrap text-muted" }
const _hoisted_142 = { class: "d-flex align-items-center" }
const _hoisted_143 = { class: "text-nowrap text-muted pb-0" }
const _hoisted_144 = { class: "d-flex align-items-center" }
const _hoisted_145 = { class: "fw-bold text-end pb-0" }
const _hoisted_146 = {
  key: 1,
  class: "card flex-1 card-flush py-4 overflow-hidden"
}
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute bottom-0 end-0 opacity-10 pe-none text-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/duotune/ecommerce/ecm001.svg",
    class: "w-150px"
  })
], -1))
const _hoisted_148 = { class: "card-header py-5" }
const _hoisted_149 = { class: "card-title align-items-start flex-column" }
const _hoisted_150 = { class: "card-toolbar" }
const _hoisted_151 = ["title"]
const _hoisted_152 = { class: "card-body pt-0" }
const _hoisted_153 = { class: "d-flex flex-column flex-xl-row d-grid gap-5" }
const _hoisted_154 = { class: "flex-fill py-2" }
const _hoisted_155 = { class: "m-0" }
const _hoisted_156 = { class: "fw-bolder text-gray-800 mb-3" }
const _hoisted_157 = { class: "fw-semibold fs-7 text-gray-600" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_160 = { class: "card flex-1 card-flush py-4 overflow-hidden" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute bottom-0 end-0 opacity-10 pe-none text-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/duotune/ecommerce/ecm006.svg",
    class: "w-150px"
  })
], -1))
const _hoisted_162 = { class: "card-header py-5" }
const _hoisted_163 = { class: "card-title align-items-start flex-column" }
const _hoisted_164 = {
  key: 0,
  class: "text-gray-400 mt-1 fw-semibold fs-6"
}
const _hoisted_165 = { class: "card-toolbar" }
const _hoisted_166 = ["title"]
const _hoisted_167 = { class: "card-body pt-0" }
const _hoisted_168 = { class: "d-flex flex-column flex-xl-row d-grid gap-5" }
const _hoisted_169 = {
  key: 0,
  class: "flex-fill py-xl-0 py-2 border-xl-end"
}
const _hoisted_170 = { class: "m-0 pe-5" }
const _hoisted_171 = { class: "fw-bolder text-gray-800 mb-3" }
const _hoisted_172 = { class: "row" }
const _hoisted_173 = {
  key: 0,
  class: "col-12 d-flex align-items-center fs-7 fw-bold text-gray-400"
}
const _hoisted_174 = { class: "svg-icon svg-icon-6 svg-icon-gray-600 me-2" }
const _hoisted_175 = { class: "svg-icon svg-icon-4 svg-icon-gray-600 ms-2" }
const _hoisted_176 = {
  key: 1,
  class: "col-12 d-flex align-items-center fs-7 fw-bold text-gray-400"
}
const _hoisted_177 = { class: "svg-icon svg-icon-6 svg-icon-gray-600 me-2" }
const _hoisted_178 = {
  key: 2,
  class: "col-12 d-flex align-items-center fs-7 fw-bold text-gray-400"
}
const _hoisted_179 = { class: "svg-icon svg-icon-6 svg-icon-gray-600 me-2" }
const _hoisted_180 = {
  key: 3,
  class: "col-12 d-flex align-items-center fs-7 fw-bold text-gray-400"
}
const _hoisted_181 = { class: "svg-icon svg-icon-6 svg-icon-gray-600 me-2" }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "- 商户原包装不拆箱。"),
  /*#__PURE__*/_createElementVNode("div", null, " - 针对腰带、包袋，将针对金属件部分贴保护膜； "),
  /*#__PURE__*/_createElementVNode("div", null, " - 针对其他商品，将在原装盒子外面加气泡膜加固保护 ")
], -1))
const _hoisted_183 = { class: "svg-icon svg-icon-4 svg-icon-gray-600 ms-2" }
const _hoisted_184 = { class: "flex-fill py-2" }
const _hoisted_185 = { class: "m-0" }
const _hoisted_186 = { class: "fw-bolder text-gray-800 mb-3" }
const _hoisted_187 = { class: "fw-semibold fs-7 text-gray-600" }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_191 = {
  key: 0,
  class: "break-all"
}
const _hoisted_192 = { class: "row gy-5 g-xl-10" }
const _hoisted_193 = { class: "col-xl-8 mb-5 mb-xl-10" }
const _hoisted_194 = { class: "row g-5 g-xl-10 h-xxl-50 mb-0 mb-xl-10" }
const _hoisted_195 = { class: "col-xxl-12" }
const _hoisted_196 = { class: "card card-flush" }
const _hoisted_197 = { class: "card-header pt-5" }
const _hoisted_198 = { class: "card-title align-items-start flex-column" }
const _hoisted_199 = { class: "card-toolbar" }
const _hoisted_200 = {
  class: "nav",
  role: "tablist"
}
const _hoisted_201 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_202 = {
  class: "nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1 active",
  "data-bs-toggle": "tab",
  href: "#kt_ordered_items_1_tab",
  "aria-selected": "true",
  role: "tab"
}
const _hoisted_203 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_204 = {
  class: "nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1",
  "data-bs-toggle": "tab",
  href: "#kt_ordered_items_2_tab",
  "aria-selected": "false",
  role: "tab",
  tabindex: "-1"
}
const _hoisted_205 = {
  key: 0,
  class: "nav-item",
  role: "presentation"
}
const _hoisted_206 = {
  class: "nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1",
  "data-bs-toggle": "tab",
  href: "#kt_ordered_items_3_tab",
  "aria-selected": "false",
  role: "tab",
  tabindex: "-1"
}
const _hoisted_207 = { class: "card-body pb-0" }
const _hoisted_208 = { class: "tab-content" }
const _hoisted_209 = {
  class: "tab-pane blockui active show",
  id: "kt_ordered_items_1_tab",
  role: "tabpanel"
}
const _hoisted_210 = { class: "table-responsive max-sm-scrollbar-hidden" }
const _hoisted_211 = { class: "table align-middle table-row-dashed fs-6 gy-5 mb-0" }
const _hoisted_212 = { class: "text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_213 = { class: "min-w-175px" }
const _hoisted_214 = { class: "min-w-100px text-start" }
const _hoisted_215 = { class: "min-w-70px text-end" }
const _hoisted_216 = { class: "min-w-100px text-end" }
const _hoisted_217 = {
  key: 0,
  class: "text-end"
}
const _hoisted_218 = { class: "min-w-100px text-end" }
const _hoisted_219 = { class: "fw-bold text-gray-800" }
const _hoisted_220 = { class: "text-end" }
const _hoisted_221 = { class: "d-flex flex-column gap-1 text-nowrap text-gray-400" }
const _hoisted_222 = ["innerHTML"]
const _hoisted_223 = ["innerHTML"]
const _hoisted_224 = ["innerHTML"]
const _hoisted_225 = ["innerHTML"]
const _hoisted_226 = { class: "text-end" }
const _hoisted_227 = { key: 0 }
const _hoisted_228 = { class: "text-end" }
const _hoisted_229 = { class: "text-end" }
const _hoisted_230 = ["colspan"]
const _hoisted_231 = { class: "text-end" }
const _hoisted_232 = ["colspan"]
const _hoisted_233 = ["colspan"]
const _hoisted_234 = { class: "text-end" }
const _hoisted_235 = { key: 0 }
const _hoisted_236 = ["colspan"]
const _hoisted_237 = { class: "text-end" }
const _hoisted_238 = ["colspan"]
const _hoisted_239 = { class: "d-flex flex-column gap-2" }
const _hoisted_240 = { class: "fs-3" }
const _hoisted_241 = { class: "text-dark text-end text-nowrap" }
const _hoisted_242 = { class: "d-flex flex-column gap-2" }
const _hoisted_243 = { class: "fs-3 fw-bolder" }
const _hoisted_244 = {
  class: "tab-pane blockui",
  id: "kt_ordered_items_2_tab",
  role: "tabpanel"
}
const _hoisted_245 = { class: "table-responsive max-sm-scrollbar-hidden" }
const _hoisted_246 = { class: "table align-middle table-row-dashed fs-6 gy-5 mb-0" }
const _hoisted_247 = { class: "text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_248 = { class: "min-w-175px text-uppercase" }
const _hoisted_249 = { class: "min-w-100px text-start text-uppercase" }
const _hoisted_250 = { class: "text-end text-uppercase" }
const _hoisted_251 = { class: "text-end text-uppercase" }
const _hoisted_252 = { class: "text-uppercase" }
const _hoisted_253 = { class: "svg-icon svg-icon-2" }
const _hoisted_254 = { class: "text-end text-uppercase" }
const _hoisted_255 = { class: "text-uppercase" }
const _hoisted_256 = { class: "svg-icon svg-icon-2" }
const _hoisted_257 = { class: "text-end text-uppercase" }
const _hoisted_258 = { class: "text-uppercase" }
const _hoisted_259 = { class: "svg-icon svg-icon-2" }
const _hoisted_260 = { class: "text-end text-uppercase" }
const _hoisted_261 = { class: "text-uppercase" }
const _hoisted_262 = { class: "svg-icon svg-icon-2" }
const _hoisted_263 = { class: "fw-bold text-gray-800" }
const _hoisted_264 = { class: "text-end" }
const _hoisted_265 = { class: "text-end" }
const _hoisted_266 = { class: "text-end" }
const _hoisted_267 = { class: "text-end" }
const _hoisted_268 = { class: "text-end" }
const _hoisted_269 = {
  key: 0,
  class: "tab-pane blockui",
  id: "kt_ordered_items_3_tab",
  role: "tabpanel"
}
const _hoisted_270 = { class: "table-responsive max-sm-scrollbar-hidden" }
const _hoisted_271 = { class: "table align-middle table-row-dashed fs-6 gy-5 mb-0" }
const _hoisted_272 = { class: "text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_273 = { class: "min-w-175px" }
const _hoisted_274 = { class: "min-w-100px text-start" }
const _hoisted_275 = { class: "min-w-70px text-end" }
const _hoisted_276 = { class: "min-w-100px text-end" }
const _hoisted_277 = { class: "min-w-70px text-end" }
const _hoisted_278 = { class: "min-w-100px text-end" }
const _hoisted_279 = { class: "fw-bold text-gray-800" }
const _hoisted_280 = { class: "text-end" }
const _hoisted_281 = { class: "text-end" }
const _hoisted_282 = { class: "text-end" }
const _hoisted_283 = { class: "text-end" }
const _hoisted_284 = {
  colspan: "5",
  class: "text-end"
}
const _hoisted_285 = { class: "text-end" }
const _hoisted_286 = {
  key: 0,
  colspan: "5",
  class: "text-end"
}
const _hoisted_287 = { key: 1 }
const _hoisted_288 = { class: "text-end" }
const _hoisted_289 = {
  colspan: "5",
  class: "text-end"
}
const _hoisted_290 = { class: "text-end" }
const _hoisted_291 = {
  colspan: "5",
  class: "text-dark text-end"
}
const _hoisted_292 = { class: "d-flex flex-column gap-2" }
const _hoisted_293 = { class: "fs-3" }
const _hoisted_294 = { class: "text-dark text-end text-nowrap" }
const _hoisted_295 = { class: "d-flex flex-column gap-2" }
const _hoisted_296 = { class: "fs-3 fw-bolder" }
const _hoisted_297 = { class: "col-xl-4 mb-xl-10" }
const _hoisted_298 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_299 = { class: "card-header align-items-center border-0 mt-4" }
const _hoisted_300 = { class: "card-title align-items-start flex-column flex-fill" }
const _hoisted_301 = { class: "" }
const _hoisted_302 = {
  key: 0,
  class: "text-muted fw-semibold fs-7"
}
const _hoisted_303 = { class: "card-toolbar" }
const _hoisted_304 = { class: "svg-icon svg-icon-2" }
const _hoisted_305 = { class: "card-body pt-5" }
const _hoisted_306 = { class: "timeline-label" }
const _hoisted_307 = { class: "timeline-label fw-bold text-gray-800 fs-6" }
const _hoisted_308 = { key: 0 }
const _hoisted_309 = { class: "timeline-badge" }
const _hoisted_310 = { class: "fw-bold text-gray-800 text-uppercase" }
const _hoisted_311 = {
  key: 0,
  class: "d-flex flex-column fs-6"
}
const _hoisted_312 = { class: "fs-7 d-flex align-items-center" }
const _hoisted_313 = ["innerHTML"]
const _hoisted_314 = {
  key: 1,
  class: "d-flex flex-column fs-6"
}
const _hoisted_315 = { class: "fs-7 d-flex align-items-center" }
const _hoisted_316 = ["innerHTML"]
const _hoisted_317 = {
  key: 2,
  class: "d-flex flex-column fs-6"
}
const _hoisted_318 = { class: "fs-7 d-flex align-items-center" }
const _hoisted_319 = ["innerHTML"]
const _hoisted_320 = {
  key: 3,
  class: "d-flex flex-column fs-6"
}
const _hoisted_321 = { class: "fs-7 d-flex align-items-center" }
const _hoisted_322 = ["innerHTML"]
const _hoisted_323 = {
  key: 4,
  class: "d-flex flex-column fs-6"
}
const _hoisted_324 = { class: "fs-7 d-flex align-items-center" }
const _hoisted_325 = ["innerHTML"]
const _hoisted_326 = {
  key: 0,
  class: "card card-flush mb-5"
}
const _hoisted_327 = { class: "card-header pt-7" }
const _hoisted_328 = { class: "card-title align-items-start flex-column flex-fill" }
const _hoisted_329 = { class: "text-gray-400 mt-1 fw-semibold fs-6" }
const _hoisted_330 = { class: "card-body" }
const _hoisted_331 = {
  key: 0,
  class: "separator separator-dashed my-6"
}
const _hoisted_332 = { class: "timeline-label" }
const _hoisted_333 = { class: "timeline-label fw-bold text-gray-800 fs-6" }
const _hoisted_334 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless fs-1 text-muted" })
], -1))
const _hoisted_335 = { class: "timeline-content d-flex flex-column ps-3" }
const _hoisted_336 = { class: "fw-bold text-gray-800" }
const _hoisted_337 = { class: "fs-7 d-flex align-items-center" }
const _hoisted_338 = { class: "text-muted" }
const _hoisted_339 = {
  key: 1,
  class: "card card-flush mb-5"
}
const _hoisted_340 = { class: "card-header pt-7" }
const _hoisted_341 = { class: "card-title align-items-start flex-column flex-fill" }
const _hoisted_342 = { class: "text-gray-400 mt-1 fw-semibold fs-6" }
const _hoisted_343 = {
  key: 0,
  class: "card-toolbar"
}
const _hoisted_344 = { class: "svg-icon svg-icon-2" }
const _hoisted_345 = { class: "card-body" }
const _hoisted_346 = {
  key: 0,
  class: "separator separator-dashed my-6"
}
const _hoisted_347 = { class: "m-0" }
const _hoisted_348 = { class: "d-flex align-items-sm-center mb-5" }
const _hoisted_349 = {
  key: 0,
  class: "symbol symbol-45px me-4"
}
const _hoisted_350 = { class: "symbol-label" }
const _hoisted_351 = { class: "d-flex align-items-center flex-row-fluid flex-wrap" }
const _hoisted_352 = { class: "flex-grow-1 me-2" }
const _hoisted_353 = { class: "text-gray-400 fs-6 fw-semibold" }
const _hoisted_354 = { class: "text-gray-800 fw-bold d-block fs-4" }
const _hoisted_355 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1))
const _hoisted_356 = { class: "overflow-auto d-flex gap-4 py-6" }
const _hoisted_357 = { class: "symbol-label bg-lighten" }
const _hoisted_358 = { class: "symbol-badge badge badge-circle bg-primary top-100 start-100" }
const _hoisted_359 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-4" }, null, -1))
const _hoisted_360 = { class: "timeline" }
const _hoisted_361 = { class: "timeline-item align-items-center mb-7" }
const _hoisted_362 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px mt-6 mb-n12" }, null, -1))
const _hoisted_363 = {
  class: "timeline-icon",
  style: {"margin-left":"11px"}
}
const _hoisted_364 = { class: "svg-icon svg-icon-2 svg-icon-danger" }
const _hoisted_365 = { class: "timeline-content m-0" }
const _hoisted_366 = { class: "fs-6 text-gray-400 fw-semibold d-block" }
const _hoisted_367 = { class: "fs-6 fw-bold text-gray-800" }
const _hoisted_368 = { class: "timeline-item align-items-center" }
const _hoisted_369 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1))
const _hoisted_370 = {
  class: "timeline-icon",
  style: {"margin-left":"11px"}
}
const _hoisted_371 = { class: "svg-icon svg-icon-2 svg-icon-info" }
const _hoisted_372 = { class: "timeline-content m-0" }
const _hoisted_373 = { class: "fs-6 text-gray-400 fw-semibold d-block" }
const _hoisted_374 = { class: "fs-6 fw-bold text-gray-800" }
const _hoisted_375 = {
  key: 2,
  class: "card card-flush mb-5"
}
const _hoisted_376 = { class: "card-header py-5" }
const _hoisted_377 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bold text-dark" }, "Open Tasks")
], -1))
const _hoisted_378 = { class: "card-toolbar" }
const _hoisted_379 = { class: "svg-icon svg-icon-1" }
const _hoisted_380 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body pt-0\" data-v-3f2d7b3c><div class=\"table-responsive max-sm-scrollbar-hidden\" data-v-3f2d7b3c><table class=\"table align-middle gs-0 gy-4\" data-v-3f2d7b3c><thead data-v-3f2d7b3c><tr data-v-3f2d7b3c><th class=\"p-0 w-10px\" data-v-3f2d7b3c></th><th class=\"p-0 w-25px\" data-v-3f2d7b3c></th><th class=\"p-0\" data-v-3f2d7b3c></th><th class=\"p-0 min-w-100px\" data-v-3f2d7b3c></th></tr></thead><tbody data-v-3f2d7b3c><tr data-v-3f2d7b3c><td data-v-3f2d7b3c><span data-kt-element=\"bullet\" class=\"bullet bullet-vertical d-flex align-items-center h-40px bg-success\" data-v-3f2d7b3c></span></td><td class=\"ps-0\" data-v-3f2d7b3c><div class=\"form-check form-check-custom form-check-success form-check-solid\" data-v-3f2d7b3c><input class=\"form-check-input\" type=\"checkbox\" value=\"\" checked data-kt-element=\"checkbox\" data-v-3f2d7b3c></div></td><td data-v-3f2d7b3c><span class=\"text-gray-800 text-hover-primary fw-bold fs-6 break-all\" data-v-3f2d7b3c>Verify Priority Management</span><span class=\"text-gray-400 fw-bold fs-7 d-block\" data-v-3f2d7b3c>Due in 2 Days</span></td><td class=\"text-end\" data-v-3f2d7b3c><span data-kt-element=\"status\" class=\"badge badge-light-success\" data-v-3f2d7b3c>Done</span></td></tr><tr data-v-3f2d7b3c><td data-v-3f2d7b3c><span data-kt-element=\"bullet\" class=\"bullet bullet-vertical d-flex align-items-center h-40px bg-primary\" data-v-3f2d7b3c></span></td><td class=\"ps-0\" data-v-3f2d7b3c><div class=\"form-check form-check-custom form-check-solid\" data-v-3f2d7b3c><input class=\"form-check-input\" type=\"checkbox\" value=\"\" data-kt-element=\"checkbox\" data-v-3f2d7b3c></div></td><td data-v-3f2d7b3c><span class=\"text-gray-800 text-hover-primary fw-bold fs-6 break-all\" data-v-3f2d7b3c>Verify Priority Management</span><span class=\"text-gray-400 fw-bold fs-7 d-block\" data-v-3f2d7b3c>Due in 2 Days</span></td><td class=\"text-end\" data-v-3f2d7b3c><span data-kt-element=\"status\" class=\"badge badge-light-primary\" data-v-3f2d7b3c>In Process</span></td></tr><tr data-v-3f2d7b3c><td data-v-3f2d7b3c><span data-kt-element=\"bullet\" class=\"bullet bullet-vertical d-flex align-items-center h-40px bg-success\" data-v-3f2d7b3c></span></td><td class=\"ps-0\" data-v-3f2d7b3c><div class=\"form-check form-check-custom form-check-success form-check-solid\" data-v-3f2d7b3c><input class=\"form-check-input\" type=\"checkbox\" value=\"\" checked data-kt-element=\"checkbox\" data-v-3f2d7b3c></div></td><td data-v-3f2d7b3c><span class=\"text-gray-800 text-hover-primary fw-bold fs-6 break-all\" data-v-3f2d7b3c>Verify Priority Management</span><span class=\"text-gray-400 fw-bold fs-7 d-block\" data-v-3f2d7b3c>Due in 2 Days</span></td><td class=\"text-end\" data-v-3f2d7b3c><span data-kt-element=\"status\" class=\"badge badge-light-success\" data-v-3f2d7b3c>Done</span></td></tr><tr data-v-3f2d7b3c><td data-v-3f2d7b3c><span data-kt-element=\"bullet\" class=\"bullet bullet-vertical d-flex align-items-center h-40px bg-primary\" data-v-3f2d7b3c></span></td><td class=\"ps-0\" data-v-3f2d7b3c><div class=\"form-check form-check-custom form-check-solid\" data-v-3f2d7b3c><input class=\"form-check-input\" type=\"checkbox\" value=\"\" data-kt-element=\"checkbox\" data-v-3f2d7b3c></div></td><td data-v-3f2d7b3c><span class=\"text-gray-800 text-hover-primary fw-bold fs-6 break-all\" data-v-3f2d7b3c>Verify Priority Management</span><span class=\"text-gray-400 fw-bold fs-7 d-block\" data-v-3f2d7b3c>Due in 2 Days</span></td><td class=\"text-end\" data-v-3f2d7b3c><span data-kt-element=\"status\" class=\"badge badge-light-primary\" data-v-3f2d7b3c>In Process</span></td></tr><tr data-v-3f2d7b3c><td data-v-3f2d7b3c><span data-kt-element=\"bullet\" class=\"bullet bullet-vertical d-flex align-items-center h-40px bg-primary\" data-v-3f2d7b3c></span></td><td class=\"ps-0\" data-v-3f2d7b3c><div class=\"form-check form-check-custom form-check-solid\" data-v-3f2d7b3c><input class=\"form-check-input\" type=\"checkbox\" value=\"\" data-kt-element=\"checkbox\" data-v-3f2d7b3c></div></td><td data-v-3f2d7b3c><span class=\"text-gray-800 text-hover-primary fw-bold fs-6 break-all\" data-v-3f2d7b3c>Verify Priority Management</span><span class=\"text-gray-400 fw-bold fs-7 d-block\" data-v-3f2d7b3c>Due in 2 Days</span></td><td class=\"text-end\" data-v-3f2d7b3c><span data-kt-element=\"status\" class=\"badge badge-light-primary\" data-v-3f2d7b3c>In Process</span></td></tr></tbody></table></div></div>", 1)
const _hoisted_381 = {
  key: 3,
  class: "card card-flush"
}
const _hoisted_382 = { class: "card-header border-0" }
const _hoisted_383 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bold text-dark" }, "Notifications", -1))
const _hoisted_384 = { class: "card-toolbar" }
const _hoisted_385 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_386 = { class: "svg-icon svg-icon-2" }
const _hoisted_387 = /*#__PURE__*/_createStaticVNode("<div class=\"menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3\" data-kt-menu=\"true\" data-v-3f2d7b3c><div class=\"menu-item px-3\" data-v-3f2d7b3c><div class=\"menu-content text-muted pb-2 px-3 fs-7 text-uppercase\" data-v-3f2d7b3c> Payments </div></div><div class=\"menu-item px-3\" data-v-3f2d7b3c><a href=\"#\" class=\"menu-link px-3\" data-v-3f2d7b3c>Create Invoice</a></div><div class=\"menu-item px-3\" data-v-3f2d7b3c><a href=\"#\" class=\"menu-link flex-stack px-3\" data-v-3f2d7b3c>Create Payment <i class=\"fas fa-exclamation-circle ms-2 fs-7\" data-bs-toggle=\"tooltip\" aria-label=\"Specify a target name for future usage and reference\" data-bs-original-title=\"Specify a target name for future usage and reference\" data-kt-initialized=\"1\" data-v-3f2d7b3c></i></a></div><div class=\"menu-item px-3\" data-v-3f2d7b3c><a href=\"#\" class=\"menu-link px-3\" data-v-3f2d7b3c>Generate Bill</a></div><div class=\"menu-item px-3\" data-kt-menu-trigger=\"hover\" data-kt-menu-placement=\"right-end\" data-v-3f2d7b3c><a href=\"#\" class=\"menu-link px-3\" data-v-3f2d7b3c><span class=\"menu-title\" data-v-3f2d7b3c>Subscription</span><span class=\"menu-arrow\" data-v-3f2d7b3c></span></a><div class=\"menu-sub menu-sub-dropdown w-175px py-4\" data-v-3f2d7b3c><div class=\"menu-item px-3\" data-v-3f2d7b3c><a href=\"#\" class=\"menu-link px-3\" data-v-3f2d7b3c>Plans</a></div><div class=\"menu-item px-3\" data-v-3f2d7b3c><a href=\"#\" class=\"menu-link px-3\" data-v-3f2d7b3c>Billing</a></div><div class=\"menu-item px-3\" data-v-3f2d7b3c><a href=\"#\" class=\"menu-link px-3\" data-v-3f2d7b3c>Statements</a></div><div class=\"separator my-2\" data-v-3f2d7b3c></div><div class=\"menu-item px-3\" data-v-3f2d7b3c><div class=\"menu-content px-3\" data-v-3f2d7b3c><label class=\"form-check form-switch form-check-custom form-check-solid\" data-v-3f2d7b3c><input class=\"form-check-input w-30px h-20px\" type=\"checkbox\" value=\"1\" checked name=\"notifications\" data-v-3f2d7b3c><span class=\"form-check-label text-muted fs-6\" data-v-3f2d7b3c>Recuring</span></label></div></div></div></div><div class=\"menu-item px-3 my-1\" data-v-3f2d7b3c><a href=\"#\" class=\"menu-link px-3\" data-v-3f2d7b3c>Settings</a></div></div>", 1)
const _hoisted_388 = { class: "card-body pt-0" }
const _hoisted_389 = { class: "d-flex align-items-center bg-light-warning rounded p-5 mb-7" }
const _hoisted_390 = { class: "svg-icon svg-icon-warning svg-icon-1 me-5" }
const _hoisted_391 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 me-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fw-bold text-gray-800 text-hover-primary fs-6"
  }, "Group lunch celebration"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold d-block" }, "Due in 2 Days")
], -1))
const _hoisted_392 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-warning py-1" }, "+28%", -1))
const _hoisted_393 = { class: "d-flex align-items-center bg-light-success rounded p-5 mb-7" }
const _hoisted_394 = { class: "svg-icon svg-icon-success svg-icon-1 me-5" }
const _hoisted_395 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 me-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fw-bold text-gray-800 text-hover-primary fs-6"
  }, "Navigation optimization"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold d-block" }, "Due in 2 Days")
], -1))
const _hoisted_396 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-success py-1" }, "+50%", -1))
const _hoisted_397 = { class: "d-flex align-items-center bg-light-danger rounded p-5 mb-7" }
const _hoisted_398 = { class: "svg-icon svg-icon-danger svg-icon-1 me-5" }
const _hoisted_399 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 me-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fw-bold text-gray-800 text-hover-primary fs-6"
  }, "Rebrand strategy planning"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold d-block" }, "Due in 5 Days")
], -1))
const _hoisted_400 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-danger py-1" }, "-27%", -1))
const _hoisted_401 = { class: "d-flex align-items-center bg-light-info rounded p-5" }
const _hoisted_402 = { class: "svg-icon svg-icon-info svg-icon-1 me-5" }
const _hoisted_403 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 me-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fw-bold text-gray-800 text-hover-primary fs-6"
  }, "Product goals strategy"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold d-block" }, "Due in 7 Days")
], -1))
const _hoisted_404 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-info py-1" }, "+8%", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_common_product = _resolveComponent("common-product")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_FsLightbox = _resolveComponent("FsLightbox")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrderOverview.summary")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("tbody", _hoisted_9, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm001.svg" })
                        ]),
                        _createTextVNode(_toDisplayString(_ctx.t("salesOrder.mbOrderType")), 1)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.formData.sales_order_extended_pim.mb_order_type), 1)
                  ]),
                  (0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                        _createElementVNode("td", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/finance/fin008.svg" })
                            ]),
                            _createTextVNode(_toDisplayString(_ctx.t("salesOrderOverview.payment")), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_18, [
                          _createTextVNode(_toDisplayString(_ctx.formData.payment_information.payment_method) + " / ", 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(
                        _ctx.paymentStatus(
                          _ctx.formData.payment_information.payment_status
                        ).textClass
                      )
                          }, _toDisplayString(_ctx.paymentStatus(
                          _ctx.formData.payment_information.payment_status
                        ).str), 3)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm006.svg" })
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.t("salesOrderOverview.shipping")), 1)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        (_ctx.formData.shipping_address.recipient_country_id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                              _createVNode(_component_el_image, {
                                class: "d-flex w-20px",
                                src: 
                            _ctx.commonCountryFlagPath(
                              _ctx.formData.shipping_address.recipient_country_id
                            )
                          
                              }, null, 8, ["src"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatMbFulfillmentType(
                          _ctx.formData.sales_order_extended_fulfillment
                            .mb_fulfillment_type,
                          false
                        )), 1),
                        _createVNode(_component_el_popover, {
                          placement: "top",
                          width: "auto",
                          trigger: "hover"
                        }, {
                          reference: _withCtx(() => [
                            _createElementVNode("span", _hoisted_25, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.formData.shipping_address.recipient_country) + " - " + _toDisplayString(_ctx.formatMbFulfillmentType(
                            _ctx.formData.sales_order_extended_fulfillment
                              .mb_fulfillment_type
                          )) + " ", 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            (0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/abstract/abs027.svg" })
                  ]),
                  _hoisted_28
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (!_ctx.isDoubleSale && !_ctx.isAuditView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrderOverview.customerCare")), 1),
                  (
                _ctx.formData.sales_order_extended_distribution.sales_manager !== '0'
              )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.t("salesOrderOverview.managedBy")) + " " + _toDisplayString(_ctx.formData.sales_order_extended_distribution.sales_manager === "0"
                  ? _ctx.t("salesOrderOverview.byCustomer")
                  : _ctx.formData.sales_order_extended_distribution.__show
                      .sales_manager), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["svg-icon svg-icon-1 mb-auto", {
                'svg-icon-warning':
                  _ctx.formData.sales_order_extended_distribution.verified_status !==
                    1 ||
                  _ctx.formData.sales_order_extended_priority_management
                    .verified_status !== 1,
                'svg-icon-success':
                  _ctx.formData.sales_order_extended_distribution.verified_status ===
                    1 &&
                  _ctx.formData.sales_order_extended_priority_management
                    .verified_status === 1,
              }]),
                    title: 
                _ctx.formData.sales_order_extended_distribution.verified_status ===
                  1 &&
                _ctx.formData.sales_order_extended_priority_management
                  .verified_status === 1
                  ? _ctx.t('salesOrder.statusVerified')
                  : _ctx.t('salesOrderOverview.pendingApproval')
              
                  }, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen048.svg" })
                  ], 10, _hoisted_34)
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("table", _hoisted_37, [
                    _createElementVNode("tbody", _hoisted_38, [
                      (
                    _ctx.formData.sales_order_extended_distribution
                      .membership_group ||
                    _ctx.formData.sales_order_extended_distribution.rfm_group_trend
                  )
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                            _createElementVNode("td", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("span", _hoisted_42, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com014.svg" })
                                ]),
                                _createTextVNode(_toDisplayString(_ctx.t("salesOrderOverview.customerGroup")), 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_43, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.formData.sales_order_extended_distribution
                        .membership_group +
                      ", " +
                      _ctx.formData.sales_order_extended_distribution.__show
                        .rfm_group_trend), 1),
                              _createVNode(_component_el_popover, {
                                placement: "top",
                                width: "auto",
                                trigger: "hover"
                              }, {
                                reference: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_45, [
                                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    innerHTML: 
                          _ctx.getSalesOrderRFMMap(
                            _ctx.formData.sales_order_extended_distribution
                              .rfm_group_trend,
                            _ctx.t
                          )
                        
                                  }, null, 8, _hoisted_44)
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.formData.sales_order_extended_priority_management
                      .high_priority_order == 1 &&
                    (_ctx.formData.sales_order_extended_priority_management
                      .priority_handling !== 0 ||
                      _ctx.formData.sales_order_extended_priority_management
                        .priority_level)
                  )
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_46, [
                            _createElementVNode("td", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("span", _hoisted_49, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/abstract/abs020.svg" })
                                ]),
                                _createTextVNode(_toDisplayString(_ctx.t("salesOrderOverview.priority")), 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_50, [
                              (
                        _ctx.formData.sales_order_extended_priority_management
                          .priority_handling !== 0
                      )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                    (
                          _ctx.formData.sales_order_extended_priority_management
                            .priority_handling === 1
                        )
                                      ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                          key: 0,
                                          src: "media/icons/duotune/general/gen005.svg"
                                        }))
                                      : (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                          key: 1,
                                          src: "media/svg/custom/part.svg"
                                        }))
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", null, _toDisplayString(_ctx.formData.sales_order_extended_priority_management.__show
                        .priority_level), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.formData.sales_order.standard_delivery_date)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [
                            _createElementVNode("td", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("span", _hoisted_55, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/calendar.svg" })
                                ]),
                                _createTextVNode(_toDisplayString(_ctx.t("salesOrderOverview.delieveryDate")), 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_56, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.customFormatDate(
                          _ctx.formData.sales_order.standard_delivery_date
                        )), 1),
                              (
                        _ctx.formData.sales_order_extended_priority_management
                          .delivery_date_diff > 0
                      )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_57, [
                                    _hoisted_58,
                                    _createElementVNode("span", _hoisted_59, "+" + _toDisplayString(_ctx.formData.sales_order_extended_priority_management
                            .delivery_date_diff), 1),
                                    _hoisted_60
                                  ]))
                                : _createCommentVNode("", true),
                              (
                        _ctx.formData.sales_order_extended_priority_management
                          .delivery_date_diff < 0
                      )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_61, [
                                    _hoisted_62,
                                    _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.formData.sales_order_extended_priority_management
                          .delivery_date_diff), 1),
                                    _hoisted_64
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                (_ctx.formData.sales_order_extended_distribution.overall_notice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                      _createElementVNode("span", _hoisted_66, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com003.svg" })
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.formData.sales_order_extended_distribution.overall_notice), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrderOverview.inventoryService")), 1),
              (
                !_ctx.isEmptyString(
                  _ctx.formData.sales_order_extended_pim.__show.pim_manager
                )
              )
                ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(_ctx.t("salesOrderOverview.managedBy")) + " " + _toDisplayString(_ctx.formData.sales_order_extended_pim.__show.pim_manager), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("span", {
                class: _normalizeClass(["svg-icon svg-icon-1 mb-auto", {
                'svg-icon-warning':
                  _ctx.formData.sales_order_extended_pim.verified_status !== 1,
                'svg-icon-success':
                  _ctx.formData.sales_order_extended_pim.verified_status === 1,
              }]),
                title: 
                _ctx.formData.sales_order_extended_pim.verified_status === 1
                  ? _ctx.t('salesOrder.statusVerified')
                  : _ctx.t('salesOrderOverview.pendingApproval')
              
              }, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen048.svg" })
              ], 10, _hoisted_75)
            ])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("table", _hoisted_78, [
                _createElementVNode("tbody", _hoisted_79, [
                  (
                    _ctx.formData.sales_order_extended_pim.definite_inventory_source
                  )
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_80, [
                        _createElementVNode("td", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("span", _hoisted_83, [
                              _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/stock.svg" })
                            ]),
                            _createTextVNode(_toDisplayString(_ctx.t("salesOrderOverview.definitedInventory")), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_84, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formData.sales_order_extended_pim
                        .definite_inventory_source), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isDoubleSale && !_ctx.isAuditView)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_85, [
                        _createElementVNode("td", _hoisted_86, [
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("span", _hoisted_88, [
                              _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/per.svg" })
                            ]),
                            _createTextVNode(_toDisplayString(_ctx.t("salesOrderOverview.minRequest")), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_89, _toDisplayString(_ctx.formData.sales_order_extended_pim
                        .minimum_inventory_request) + "% ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.sales_order.total_qty_confirmed > 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_90, [
                        _createElementVNode("td", _hoisted_91, [
                          _createElementVNode("div", _hoisted_92, [
                            _createElementVNode("span", _hoisted_93, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm004.svg" })
                            ]),
                            _createTextVNode(_toDisplayString(_ctx.t("salesOrderOverview.inventoryStatus")), 1)
                          ])
                        ]),
                        _createElementVNode("td", {
                          class: "fw-bold text-end",
                          innerHTML: 
                      _ctx.t('salesOrderOverview.inventoryStatusLabel', [
                        _ctx.formData.sales_order.total_qty_confirmed,
                        _ctx.formData.sales_order.total_qty_ordered,
                      ])
                    
                        }, null, 8, _hoisted_94)
                      ]))
                    : (
                    _ctx.formData.sales_order_extended_pim
                      .inventory_confirmation_date
                  )
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_95, [
                          _createElementVNode("td", _hoisted_96, [
                            _createElementVNode("div", _hoisted_97, [
                              _createElementVNode("span", _hoisted_98, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen013.svg" })
                              ]),
                              _createTextVNode(_toDisplayString(_ctx.t("salesOrderOverview.confDate")), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_99, _toDisplayString(_ctx.customFormatDate(
                        _ctx.formData.sales_order_extended_pim
                          .inventory_confirmation_date
                      )), 1)
                        ]))
                      : _createCommentVNode("", true),
                  (_ctx.formData.sales_order.shipment.id)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_100, [
                        _createElementVNode("td", _hoisted_101, [
                          _createElementVNode("div", _hoisted_102, [
                            _createElementVNode("span", _hoisted_103, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen017.svg" })
                            ]),
                            _createTextVNode(_toDisplayString(_ctx.t("salesOrderOverview.packaging")), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_104, [
                          _createVNode(_component_router_link, {
                            to: 
                        '/sales-order/order-overview/' +
                        _ctx.$route.params.id +
                        '/order-tracking'
                      ,
                            class: "text-primary mb-1",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_105, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com012.svg" })
                              ]),
                              _createTextVNode(_toDisplayString(_ctx.t("salesOrderOverview.orderProgressionViewDetails")), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_106, [
        _createElementVNode("div", _hoisted_107, [
          (!_ctx.isDoubleSale && !_ctx.isAuditView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                _hoisted_109,
                _createElementVNode("div", _hoisted_110, [
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrderOverview.settlementService")), 1),
                    (
                  !_ctx.isEmptyString(
                    _ctx.formData.sales_order_extended_settlement
                      .offline_payment_controller
                  )
                )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_112, _toDisplayString(_ctx.t("salesOrderOverview.managedBy")) + " " + _toDisplayString(_ctx.formData.sales_order_extended_settlement
                    .offline_payment_controller), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["svg-icon svg-icon-1 mb-auto", {
                  'svg-icon-warning':
                    _ctx.formData.sales_order_extended_settlement.verified_status !==
                    1,
                  'svg-icon-success':
                    _ctx.formData.sales_order_extended_settlement.verified_status ===
                    1,
                }]),
                      title: 
                  _ctx.formData.sales_order_extended_settlement.verified_status === 1
                    ? _ctx.t('salesOrder.statusVerified')
                    : _ctx.t('salesOrderOverview.pendingApproval')
                
                    }, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen048.svg" })
                    ], 10, _hoisted_114)
                  ])
                ]),
                _createElementVNode("div", _hoisted_115, [
                  _createElementVNode("div", _hoisted_116, [
                    (
                  _ctx.formData.sales_order_extended_settlement.settlement_mode ||
                  (_ctx.formData.sales_order_extended_settlement
                    .deposit_in_advance === _ctx.CommonSwtich.Active &&
                    _ctx.formData.sales_order_extended_settlement
                      .offline_payment_due_date) ||
                  (_ctx.formData.sales_order_extended_settlement
                    .offline_payment_controlling ===
                    _ctx.CommonRequiredSwtich.Requried &&
                    _ctx.formData.sales_order_extended_settlement
                      .track_payment_status)
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                          _createElementVNode("div", _hoisted_118, [
                            _createElementVNode("h6", _hoisted_119, _toDisplayString(_ctx.t("salesOrderOverview.settlementServiceSelectedServices")), 1),
                            _createElementVNode("div", _hoisted_120, [
                              (
                        _ctx.formData.sales_order_extended_settlement.settlement_mode
                      )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                    _createElementVNode("span", _hoisted_122, [
                                      _createElementVNode("span", _hoisted_123, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen057.svg" })
                                      ]),
                                      _createTextVNode(_toDisplayString(_ctx.formData.sales_order_extended_settlement
                            .settlement_mode), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (
                        _ctx.formData.sales_order_extended_settlement
                          .deposit_in_advance === _ctx.CommonSwtich.Active &&
                        _ctx.formData.sales_order_extended_settlement
                          .offline_payment_due_date
                      )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                    _createElementVNode("span", _hoisted_125, [
                                      _createElementVNode("span", _hoisted_126, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen057.svg" })
                                      ]),
                                      _createElementVNode("span", null, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("salesOrder.depositInAdvance")) + " / ", 1),
                                        _createElementVNode("span", _hoisted_127, _toDisplayString(_ctx.paymentStatus(
                              _ctx.formData.payment_information.payment_status
                            ).str), 1),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.t("salesOrderOverview.on")) + " ", 1),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.customFormatDate(
                              _ctx.formData.sales_order_extended_settlement
                                .offline_payment_due_date
                            )), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (
                        _ctx.formData.sales_order_extended_settlement
                          .offline_payment_controlling ===
                          _ctx.CommonRequiredSwtich.Requried &&
                        _ctx.formData.sales_order_extended_settlement
                          .track_payment_status
                      )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                    _createElementVNode("span", _hoisted_129, [
                                      _createElementVNode("span", _hoisted_130, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen057.svg" })
                                      ]),
                                      _createTextVNode(_toDisplayString(_ctx.t("salesOrderOverview.offlinePaymentStatusTrack")), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("div", _hoisted_132, [
                        _createElementVNode("div", _hoisted_133, [
                          _createElementVNode("table", _hoisted_134, [
                            _createElementVNode("tbody", _hoisted_135, [
                              (_ctx.formData.sales_order.date_of_arrival)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_136, [
                                    _createElementVNode("td", _hoisted_137, [
                                      _createElementVNode("div", _hoisted_138, _toDisplayString(_ctx.formData.sales_order_identifier
                                  .settlement_status !==
                                _ctx.SalesOrderSettlementStatus.SettlementCompleted
                                  ? _ctx.t(
                                      "salesOrderOverview.estPaymentReceivedDate"
                                    )
                                  : _ctx.t(
                                      "salesOrderOverview.actualPaymentReceivedDate"
                                    )), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_139, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.customFormatDate(
                                _ctx.formData.sales_order.date_of_arrival
                              )), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (
                            _ctx.formData.sales_order_extended_fulfillment
                              .bc_custom_clearance === _ctx.CommonSwtich.Active
                          )
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_140, [
                                    _createElementVNode("td", _hoisted_141, [
                                      _createElementVNode("div", _hoisted_142, _toDisplayString(_ctx.t("salesOrderOverview.bcPayment")), 1)
                                    ]),
                                    _createElementVNode("td", {
                                      class: _normalizeClass(["fw-bold text-end text-danger", {
                              'text-success':
                                _ctx.formData.sales_order_extended_fulfillment
                                  .bc_custom_clearance === _ctx.CommonSwtich.Active,
                            }])
                                    }, _toDisplayString(_ctx.formData.sales_order_extended_fulfillment
                                .bc_custom_clearance === _ctx.CommonSwtich.Active
                                ? _ctx.t("common.yes")
                                : _ctx.t("common.no")), 3)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_143, [
                                  _createElementVNode("div", _hoisted_144, _toDisplayString(_ctx.t("salesOrder.billingAddress")), 1)
                                ]),
                                _createElementVNode("td", _hoisted_145, _toDisplayString(_ctx.formData.billing_address
                                .billing_street_address ===
                              _ctx.formData.shipping_address.recipient_street_address
                                ? _ctx.t("salesOrderOverview.sameShippingAddress")
                                : _ctx.t(
                                    "salesOrderOverview.differentShippingAddresses"
                                  )), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_146, [
                _hoisted_147,
                _createElementVNode("div", _hoisted_148, [
                  _createElementVNode("div", _hoisted_149, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrderOverview.billingAddress")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_150, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["svg-icon svg-icon-1 mb-auto", {
                  'svg-icon-warning':
                    _ctx.formData.sales_order_extended_settlement.verified_status !==
                    1,
                  'svg-icon-success':
                    _ctx.formData.sales_order_extended_settlement.verified_status ===
                    1,
                }]),
                      title: 
                  _ctx.formData.sales_order_extended_settlement.verified_status === 1
                    ? _ctx.t('salesOrder.statusVerified')
                    : _ctx.t('salesOrderOverview.pendingApproval')
                
                    }, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen048.svg" })
                    ], 10, _hoisted_151)
                  ])
                ]),
                _createElementVNode("div", _hoisted_152, [
                  _createElementVNode("div", _hoisted_153, [
                    _createElementVNode("div", _hoisted_154, [
                      _createElementVNode("div", _hoisted_155, [
                        _createElementVNode("h6", _hoisted_156, _toDisplayString(_ctx.formData.billing_address.firstname) + " " + _toDisplayString(_ctx.formData.billing_address.lastname), 1),
                        _createElementVNode("div", _hoisted_157, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formData.billing_address.street), 1),
                          _hoisted_158,
                          _createElementVNode("span", null, _toDisplayString(_ctx.formData.billing_address.postcode) + _toDisplayString(_ctx.formData.billing_address.city
                          ? " " + _ctx.formData.billing_address.city
                          : ""), 1),
                          _hoisted_159,
                          _createElementVNode("span", null, _toDisplayString(_ctx.formData.billing_address.country), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])),
          _createElementVNode("div", _hoisted_160, [
            _hoisted_161,
            _createElementVNode("div", _hoisted_162, [
              _createElementVNode("div", _hoisted_163, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrderOverview.fulfillmentService")), 1),
                (
                  !_ctx.isEmptyString(
                    _ctx.formData.sales_order_extended_fulfillment
                      .fulfillment_manager
                  ) &&
                  !_ctx.isDoubleSale &&
                  !_ctx.isAuditView
                )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_164, _toDisplayString(_ctx.t("salesOrderOverview.managedBy")) + " " + _toDisplayString(_ctx.formData.sales_order_extended_fulfillment.fulfillment_manager), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_165, [
                _createElementVNode("span", {
                  class: _normalizeClass(["svg-icon svg-icon-1 mb-auto", {
                  'svg-icon-warning':
                    _ctx.formData.sales_order_extended_fulfillment
                      .verified_status !== 1,
                  'svg-icon-success':
                    _ctx.formData.sales_order_extended_fulfillment
                      .verified_status === 1,
                }]),
                  title: 
                  _ctx.formData.sales_order_extended_fulfillment.verified_status ===
                  1
                    ? _ctx.t('salesOrder.statusVerified')
                    : _ctx.t('salesOrderOverview.pendingApproval')
                
                }, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen048.svg" })
                ], 10, _hoisted_166)
              ])
            ]),
            _createElementVNode("div", _hoisted_167, [
              _createElementVNode("div", _hoisted_168, [
                (!_ctx.isDoubleSale && !_ctx.isAuditView)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (
                    _ctx.formData.sales_order_extended_fulfillment
                      .tax_duties_terms ||
                    (_ctx.formData.sales_order_extended_fulfillment
                      .additional_fulfillment_service === _ctx.CommonSwtich.Active &&
                      _ctx.formData.sales_order_extended_fulfillment
                        .partial_shipment) ||
                    (_ctx.formData.sales_order_extended_fulfillment
                      .additional_fulfillment_service === _ctx.CommonSwtich.Active &&
                      _ctx.formData.sales_order_extended_fulfillment
                        .required_documents.length > 0) ||
                    (_ctx.formData.sales_order_extended_fulfillment
                      .additional_fulfillment_service === _ctx.CommonSwtich.Active &&
                      _ctx.formData.sales_order_extended_fulfillment
                        .packaging_service)
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                            _createElementVNode("div", _hoisted_170, [
                              _createElementVNode("h6", _hoisted_171, _toDisplayString(_ctx.t(
                          "salesOrderOverview.fulfillmentServiceSelectedServices"
                        )), 1),
                              _createElementVNode("div", _hoisted_172, [
                                (
                          _ctx.formData.sales_order_extended_fulfillment
                            .tax_duties_terms
                        )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                                      _createElementVNode("span", _hoisted_174, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen057.svg" })
                                      ]),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.formData.sales_order_extended_fulfillment.__show
                            .tax_duties_terms), 1),
                                      _createVNode(_component_el_popover, {
                                        placement: "top",
                                        width: "auto",
                                        trigger: "hover"
                                      }, {
                                        reference: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_175, [
                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getCustomerClearanceModeMap(
                              _ctx.formData.sales_order_extended_fulfillment
                                .tax_duties_terms
                            )) + " ", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                          _ctx.formData.sales_order_extended_fulfillment
                            .additional_fulfillment_service ===
                            _ctx.CommonSwtich.Active &&
                          _ctx.formData.sales_order_extended_fulfillment
                            .partial_shipment
                        )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                                      _createElementVNode("span", _hoisted_177, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen057.svg" })
                                      ]),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.formData.sales_order_extended_fulfillment.__show
                            .partial_shipment), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                          _ctx.formData.sales_order_extended_fulfillment
                            .additional_fulfillment_service ===
                            _ctx.CommonSwtich.Active &&
                          _ctx.formData.sales_order_extended_fulfillment
                            .required_documents.length > 0
                        )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                                      _createElementVNode("span", _hoisted_179, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen057.svg" })
                                      ]),
                                      _createElementVNode("span", null, _toDisplayString(String(
                            _ctx.formData.sales_order_extended_fulfillment
                              .required_documents
                          )), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                          _ctx.formData.sales_order_extended_fulfillment
                            .additional_fulfillment_service ===
                            _ctx.CommonSwtich.Active &&
                          _ctx.formData.sales_order_extended_fulfillment
                            .packaging_service
                        )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                                      _createElementVNode("span", _hoisted_181, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen057.svg" })
                                      ]),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.formData.sales_order_extended_fulfillment.__show
                            .packaging_service), 1),
                                      _createVNode(_component_el_popover, {
                                        placement: "top",
                                        width: "auto",
                                        trigger: "hover"
                                      }, {
                                        reference: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_183, [
                                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _hoisted_182
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_184, [
                  _createElementVNode("div", _hoisted_185, [
                    _createElementVNode("h6", _hoisted_186, _toDisplayString(_ctx.formData.shipping_address.recipient_name), 1),
                    _createElementVNode("div", _hoisted_187, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.formData.shipping_address.recipient_street_address), 1),
                      _hoisted_188,
                      _createElementVNode("span", null, _toDisplayString(_ctx.formData.shipping_address.recipient_postal_code) + _toDisplayString(_ctx.formData.shipping_address.recipient_city
                          ? " " + _ctx.formData.shipping_address.recipient_city
                          : ""), 1),
                      _hoisted_189,
                      _createElementVNode("span", null, _toDisplayString(_ctx.formData.shipping_address.recipient_country), 1)
                    ]),
                    _hoisted_190,
                    (!_ctx.isDoubleSale && !_ctx.isAuditView)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_191, _toDisplayString(_ctx.formData.shipping_address.recipient_telephone_code) + " " + _toDisplayString(_ctx.formData.shipping_address.recipient_mobile_no) + " / " + _toDisplayString(_ctx.formData.billing_address.billing_contact_email), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_192, [
        _createElementVNode("div", _hoisted_193, [
          _createElementVNode("div", _hoisted_194, [
            _createElementVNode("div", _hoisted_195, [
              _createElementVNode("div", _hoisted_196, [
                _createElementVNode("div", _hoisted_197, [
                  _createElementVNode("div", _hoisted_198, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrderOverview.orderItems")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_199, [
                    _createElementVNode("ul", _hoisted_200, [
                      _createElementVNode("li", _hoisted_201, [
                        _createElementVNode("a", _hoisted_202, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsDetails")), 1)
                      ]),
                      _createElementVNode("li", _hoisted_203, [
                        _createElementVNode("a", _hoisted_204, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsProgress")), 1)
                      ]),
                      (_ctx.options.invoiceData.list.length !== 0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_205, [
                            _createElementVNode("a", _hoisted_206, _toDisplayString(_ctx.t("salesOrderOverview.adjustMemos")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_207, [
                  _createElementVNode("div", _hoisted_208, [
                    _createElementVNode("div", _hoisted_209, [
                      _createElementVNode("div", _hoisted_210, [
                        _createElementVNode("table", _hoisted_211, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", _hoisted_212, [
                              _createElementVNode("th", _hoisted_213, _toDisplayString(_ctx.t("order.product")), 1),
                              _createElementVNode("th", _hoisted_214, _toDisplayString(_ctx.t("order.sku")), 1),
                              _createElementVNode("th", _hoisted_215, _toDisplayString(_ctx.t("order.qty")), 1),
                              _createElementVNode("th", _hoisted_216, _toDisplayString(_ctx.t("order.unitPrice")), 1),
                              (!_ctx.isDoubleSale && !_ctx.isAuditView)
                                ? (_openBlock(), _createElementBlock("th", _hoisted_217, [
                                    _createElementVNode("div", null, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsDiscount")), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("th", _hoisted_218, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsTotal")), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", _hoisted_219, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.ordered_items, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createVNode(_component_common_product, {
                                  gallery: [
                                {
                                  id: 0,
                                  origin_url: item.image,
                                },
                              ],
                                  brand_id: item.brand,
                                  brand_article_no: item.brand_article_number,
                                  product_identifier_id: '0',
                                  source_link: '',
                                  name: item.sku_name_cn,
                                  name_en: item.sku_name_en,
                                  color: item.color,
                                  size: item.size
                                }, null, 8, ["gallery", "brand_id", "brand_article_no", "name", "name_en", "color", "size"]),
                                _createElementVNode("td", _hoisted_220, [
                                  _createElementVNode("div", _hoisted_221, [
                                    _createElementVNode("span", {
                                      innerHTML: 
                                    _ctx.t('salesOrderOverview.qtyOrdered', [
                                      item.qty_ordered,
                                    ])
                                  
                                    }, null, 8, _hoisted_222),
                                    (item.paid_qty > 0 && !_ctx.isAuditView)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          innerHTML: 
                                    _ctx.t('salesOrderOverview.qtyPaid', [
                                      item.paid_qty,
                                    ])
                                  
                                        }, null, 8, _hoisted_223))
                                      : _createCommentVNode("", true),
                                    (item.qty_refunded > 0 && !_ctx.isAuditView)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          innerHTML: 
                                    _ctx.t('salesOrderOverview.qtyRefunded', [
                                      item.qty_refunded,
                                    ])
                                  
                                        }, null, 8, _hoisted_224))
                                      : _createCommentVNode("", true),
                                    (item.qty_canceled > 0 && !_ctx.isAuditView)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 2,
                                          innerHTML: 
                                    _ctx.t('salesOrderOverview.qtyCanceled', [
                                      item.qty_canceled,
                                    ])
                                  
                                        }, null, 8, _hoisted_225))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_226, _toDisplayString(_ctx.formData.base_currency_code == "￥"
                                  ? _ctx.$currency.currency(
                                      item.base_unit_sales_order_price,
                                      2,
                                      ".",
                                      "",
                                      _ctx.formData.base_currency_code + " "
                                    )
                                  : _ctx.$currency.currency(
                                      item.base_unit_sales_order_price,
                                      2,
                                      ",",
                                      ".",
                                      _ctx.formData.base_currency_code + " "
                                    )), 1),
                                (!_ctx.isDoubleSale && !_ctx.isAuditView)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_227, [
                                      _createElementVNode("div", _hoisted_228, _toDisplayString(parseFloat(item.base_discount_percent) === 0
                                    ? _ctx.$currency.currency(
                                        (1 -
                                          item.base_selling_price /
                                            item.base_original_price) *
                                          100,
                                        2,
                                        ",",
                                        "",
                                        ""
                                      )
                                    : _ctx.$currency.currency(
                                        item.base_discount_percent,
                                        2,
                                        ",",
                                        "",
                                        ""
                                      )) + "% ", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("td", _hoisted_229, _toDisplayString(_ctx.formData.base_currency_code == "￥"
                                  ? _ctx.$currency.currency(
                                      item.base_row_total_incl_tax,
                                      2,
                                      ".",
                                      "",
                                      _ctx.formData.base_currency_code + " "
                                    )
                                  : _ctx.$currency.currency(
                                      item.base_row_total_incl_tax,
                                      2,
                                      ",",
                                      ".",
                                      _ctx.formData.base_currency_code + " "
                                    )), 1)
                              ]))
                            }), 128)),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", {
                                colspan: _ctx.isAuditView || _ctx.isDoubleSale ? 4 : 5,
                                class: "text-end"
                              }, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsSubtotal")), 9, _hoisted_230),
                              _createElementVNode("td", _hoisted_231, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.formData.order_totals.base_sub_total,
                                  2,
                                  ",",
                                  ".",
                                  _ctx.formData.base_currency_code + " "
                                )), 1)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVatArr, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                (_ctx.isDoubleSale && item.tax_percent === 0)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 0,
                                      colspan: _ctx.isAuditView || _ctx.isDoubleSale ? 4 : 5,
                                      class: "text-end"
                                    }, _toDisplayString(_ctx.formData.shipping_address
                                  .recipient_country_id == "DE"
                                  ? _ctx.t(
                                      "salesOrderOverview.orderItemsVatHasParams",
                                      [19]
                                    ) + "*"
                                  : _ctx.t(
                                      "salesOrderOverview.orderItemsTaxHasParams",
                                      [19]
                                    ) + "*"), 9, _hoisted_232))
                                  : (_openBlock(), _createElementBlock("td", {
                                      key: 1,
                                      colspan: _ctx.isAuditView ? 4 : 5,
                                      class: "text-end"
                                    }, _toDisplayString(_ctx.formData.shipping_address
                                  .recipient_country_id == "DE"
                                  ? _ctx.t(
                                      "salesOrderOverview.orderItemsVatHasParams",
                                      [
                                        _ctx.$currency.currency(
                                          item.tax_percent,
                                          2,
                                          ".",
                                          "",
                                          ""
                                        ),
                                      ]
                                    )
                                  : _ctx.t(
                                      "salesOrderOverview.orderItemsTaxHasParams",
                                      [
                                        _ctx.$currency.currency(
                                          item.tax_percent,
                                          2,
                                          ".",
                                          "",
                                          ""
                                        ),
                                      ]
                                    )), 9, _hoisted_233)),
                                _createElementVNode("td", _hoisted_234, _toDisplayString(_ctx.$currency.currency(
                                  item.base_tax_amount,
                                  2,
                                  ",",
                                  ".",
                                  _ctx.formData.base_currency_code + " "
                                )), 1)
                              ]))
                            }), 128)),
                            (
                              Number(
                                _ctx.formData.order_totals.base_shipping_amount
                              ) !== 0
                            )
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_235, [
                                  _createElementVNode("td", {
                                    colspan: _ctx.isAuditView || _ctx.isDoubleSale ? 4 : 5,
                                    class: "text-end"
                                  }, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsShippingFee")), 9, _hoisted_236),
                                  _createElementVNode("td", _hoisted_237, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.formData.order_totals.base_shipping_amount,
                                  2,
                                  ",",
                                  ".",
                                  _ctx.formData.base_currency_code + " "
                                )), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", {
                                colspan: _ctx.isAuditView || _ctx.isDoubleSale ? 4 : 5,
                                class: "text-dark text-end"
                              }, [
                                _createElementVNode("div", _hoisted_239, [
                                  _createElementVNode("span", _hoisted_240, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsGrandTotal")), 1)
                                ])
                              ], 8, _hoisted_238),
                              _createElementVNode("td", _hoisted_241, [
                                _createElementVNode("div", _hoisted_242, [
                                  _createElementVNode("span", _hoisted_243, _toDisplayString(_ctx.$currency.currency(
                                    _ctx.formData.order_totals
                                      .base_grand_total_gross,
                                    2,
                                    ",",
                                    ".",
                                    _ctx.formData.base_currency_code + " "
                                  )), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_244, [
                      _createElementVNode("div", _hoisted_245, [
                        _createElementVNode("table", _hoisted_246, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", _hoisted_247, [
                              _createElementVNode("th", _hoisted_248, _toDisplayString(_ctx.t("order.product")), 1),
                              _createElementVNode("th", _hoisted_249, _toDisplayString(_ctx.t("order.sku")), 1),
                              _createElementVNode("th", _hoisted_250, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsQty")), 1),
                              _createElementVNode("th", _hoisted_251, [
                                _createVNode(_component_el_popover, {
                                  placement: "top",
                                  width: "auto",
                                  trigger: "hover"
                                }, {
                                  reference: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_253, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm005.svg" })
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_252, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsConf")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("th", _hoisted_254, [
                                _createVNode(_component_el_popover, {
                                  placement: "top",
                                  width: "auto",
                                  trigger: "hover"
                                }, {
                                  reference: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_256, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm009.svg" })
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_255, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsStock")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("th", _hoisted_257, [
                                _createVNode(_component_el_popover, {
                                  placement: "top",
                                  width: "auto",
                                  trigger: "hover"
                                }, {
                                  reference: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_259, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm010.svg" })
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_258, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsChk")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("th", _hoisted_260, [
                                _createVNode(_component_el_popover, {
                                  placement: "top",
                                  width: "auto",
                                  trigger: "hover"
                                }, {
                                  reference: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_262, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm006.svg" })
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_261, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsShipped")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _createElementVNode("tbody", _hoisted_263, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.ordered_items, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createVNode(_component_common_product, {
                                  gallery: [
                                {
                                  id: 0,
                                  origin_url: item.image,
                                },
                              ],
                                  brand_id: item.brand,
                                  brand_article_no: item.brand_article_number,
                                  product_identifier_id: '0',
                                  source_link: '',
                                  name: item.sku_name_cn,
                                  name_en: item.sku_name_en,
                                  color: item.color,
                                  size: item.size
                                }, null, 8, ["gallery", "brand_id", "brand_article_no", "name", "name_en", "color", "size"]),
                                _createElementVNode("td", _hoisted_264, _toDisplayString(item.qty_ordered), 1),
                                _createElementVNode("td", _hoisted_265, _toDisplayString(item.confirmed_qty), 1),
                                _createElementVNode("td", _hoisted_266, _toDisplayString(item.stock_in_qty), 1),
                                _createElementVNode("td", _hoisted_267, _toDisplayString(item.passed_qty), 1),
                                _createElementVNode("td", _hoisted_268, _toDisplayString(parseInt(item.shipped_qty)), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    (_ctx.options.invoiceData.list.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_269, [
                          _createElementVNode("div", _hoisted_270, [
                            _createElementVNode("table", _hoisted_271, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", _hoisted_272, [
                                  _createElementVNode("th", _hoisted_273, _toDisplayString(_ctx.t("order.product")), 1),
                                  _createElementVNode("th", _hoisted_274, _toDisplayString(_ctx.t("order.sku")), 1),
                                  _createElementVNode("th", _hoisted_275, _toDisplayString(_ctx.t("salesOrderOverview.adjQty")), 1),
                                  _createElementVNode("th", _hoisted_276, _toDisplayString(_ctx.t("salesOrderOverview.adjNetPrice")), 1),
                                  _createElementVNode("th", _hoisted_277, _toDisplayString(_ctx.t("order.tax")), 1),
                                  _createElementVNode("th", _hoisted_278, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsTotal")), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", _hoisted_279, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.invoiceData.list, (item, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    _createVNode(_component_common_product, {
                                      gallery: item.gallery,
                                      brand_id: item.brand,
                                      brand_article_no: item.product_number,
                                      product_identifier_id: '0',
                                      source_link: '',
                                      name: item.product_name,
                                      name_en: item.product_name,
                                      color: item.original_color,
                                      size: item.size
                                    }, null, 8, ["gallery", "brand_id", "brand_article_no", "name", "name_en", "color", "size"]),
                                    _createElementVNode("td", _hoisted_280, _toDisplayString(item.qty), 1),
                                    _createElementVNode("td", _hoisted_281, _toDisplayString(_ctx.formData.base_currency_code == "￥"
                                  ? _ctx.$currency.currency(
                                      item.unit_net_amount,
                                      2,
                                      ".",
                                      "",
                                      _ctx.formData.base_currency_code + " "
                                    )
                                  : _ctx.$currency.currency(
                                      item.unit_net_amount,
                                      2,
                                      ",",
                                      ".",
                                      _ctx.formData.base_currency_code + " "
                                    )), 1),
                                    _createElementVNode("td", _hoisted_282, _toDisplayString(_ctx.$currency.currency(
                                  item.tax_percent,
                                  2,
                                  ".",
                                  "",
                                  ""
                                )) + "% ", 1),
                                    _createElementVNode("td", _hoisted_283, _toDisplayString(_ctx.formData.base_currency_code == "￥"
                                  ? _ctx.$currency.currency(
                                      item.net_total,
                                      2,
                                      ".",
                                      "",
                                      _ctx.formData.base_currency_code + " "
                                    )
                                  : _ctx.$currency.currency(
                                      item.net_total,
                                      2,
                                      ",",
                                      ".",
                                      _ctx.formData.base_currency_code + " "
                                    )), 1)
                                  ]))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.invoiceData
                              .invoices, (item, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    _createElementVNode("td", _hoisted_284, _toDisplayString(_ctx.t("order.subtotalExclTax")) + ": ", 1),
                                    _createElementVNode("td", _hoisted_285, _toDisplayString(_ctx.$currency.currency(
                                  item.total_net_amount,
                                  2,
                                  ",",
                                  ".",
                                  _ctx.formData.base_currency_code + " "
                                )), 1)
                                  ]))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.invoiceData.invoices, (list, key) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getInvoiceVatArr(list), (item, index) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                        (_ctx.isDoubleSale && item.tax_percent === 0)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_286, _toDisplayString(_ctx.formData.shipping_address
                                    .recipient_country_id == "DE"
                                    ? _ctx.t(
                                        "salesOrderOverview.orderItemsVatHasParams",
                                        [19]
                                      ) + "*"
                                    : _ctx.t(
                                        "salesOrderOverview.orderItemsTaxHasParams",
                                        [19]
                                      ) + "*"), 1))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_287, _toDisplayString(_ctx.formData.shipping_address
                                    .recipient_country_id == "DE"
                                    ? _ctx.t(
                                        "salesOrderOverview.orderItemsVatHasParams",
                                        [
                                          _ctx.$currency.currency(
                                            item.tax_percent,
                                            2,
                                            ".",
                                            "",
                                            ""
                                          ),
                                        ]
                                      )
                                    : _ctx.t(
                                        "salesOrderOverview.orderItemsTaxHasParams",
                                        [
                                          _ctx.$currency.currency(
                                            item.tax_percent,
                                            2,
                                            ".",
                                            "",
                                            ""
                                          ),
                                        ]
                                      )), 1)),
                                        _createElementVNode("td", _hoisted_288, _toDisplayString(_ctx.$currency.currency(
                                    item.base_tax_amount,
                                    2,
                                    ",",
                                    ".",
                                    _ctx.formData.base_currency_code + " "
                                  )), 1)
                                      ]))
                                    }), 128))
                                  ], 64))
                                }), 128)),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_289, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsShippingFee")), 1),
                                  _createElementVNode("td", _hoisted_290, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.options.invoiceData.invoices[0].shipping_fee,
                                  2,
                                  ",",
                                  ".",
                                  _ctx.formData.base_currency_code + " "
                                )), 1)
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.invoiceData
                              .invoices, (item, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    _createElementVNode("td", _hoisted_291, [
                                      _createElementVNode("div", _hoisted_292, [
                                        _createElementVNode("span", _hoisted_293, _toDisplayString(Number(item.unit_gross_amount_total) >= 0
                                        ? _ctx.t("salesOrderOverview.debitMemo")
                                        : _ctx.t("salesOrderOverview.creditorMemo")) + ":", 1)
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_294, [
                                      _createElementVNode("div", _hoisted_295, [
                                        _createElementVNode("span", _hoisted_296, _toDisplayString(_ctx.$currency.currency(
                                      item.unit_gross_amount_total,
                                      2,
                                      ",",
                                      ".",
                                      _ctx.formData.base_currency_code + " "
                                    )), 1)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_297, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_298, [
            _createElementVNode("div", _hoisted_299, [
              _createElementVNode("div", _hoisted_300, [
                _createElementVNode("h3", _hoisted_301, _toDisplayString(_ctx.t("salesOrderOverview.orderProgression")), 1),
                (!_ctx.isDoubleSale && !_ctx.isAuditView)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_302, _toDisplayString(_ctx.t("salesOrderOverview.clickButtonToCheckMoreDetails")), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_303, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeOrderProgressionAll && _ctx.changeOrderProgressionAll(...args))),
                  type: "button",
                  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                }, [
                  _createElementVNode("span", _hoisted_304, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen024.svg" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_305, [
              _createElementVNode("div", _hoisted_306, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOrderProgressionFilter, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "timeline-item",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_307, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.date, (row, rowIndex) => {
                        return (_openBlock(), _createElementBlock("span", { key: rowIndex }, [
                          (rowIndex == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_308, _toDisplayString(_ctx.customFormatDate(row, "MM.DD")), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_309, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa fa-genderless fs-1", {
                      'text-success': item.crossed === 1,
                      'text-primary': _ctx.getOrderProgressionCurrentStatus(index),
                      'text-gray-400':
                        !_ctx.getOrderProgressionCurrentStatus(index) &&
                        item.crossed === 0,
                    }])
                      }, null, 2)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["timeline-content d-flex flex-column ps-3 break-all", {
                    'opacity-50':
                      !_ctx.getOrderProgressionCurrentStatus(index) &&
                      item.crossed === 0,
                  }])
                    }, [
                      _createElementVNode("span", _hoisted_310, _toDisplayString(_ctx.getOrderTrackingOrderProgressionKeyMap(item.key, _ctx.t)), 1),
                      (item.completion.length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (
                        item.key ===
                        _ctx.OrderTrackingOrderProgressionKey.OrderAssign
                      )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_311, [
                                  _createElementVNode("div", _hoisted_312, [
                                    _createElementVNode("div", {
                                      class: "text-muted",
                                      innerHTML: 
                              _ctx.t(
                                'salesOrderOverview.orderProgressionAssignedProgress',
                                item.completion
                              )
                            
                                    }, null, 8, _hoisted_313)
                                  ])
                                ]))
                              : (
                        item.key ===
                        _ctx.OrderTrackingOrderProgressionKey.OrderApproved
                      )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_314, [
                                    _createElementVNode("div", _hoisted_315, [
                                      _createElementVNode("div", {
                                        class: "text-muted",
                                        innerHTML: 
                              _ctx.t(
                                'salesOrderOverview.orderProgressionApprovedTotal',
                                item.completion
                              )
                            
                                      }, null, 8, _hoisted_316)
                                    ])
                                  ]))
                                : (
                        item.key ===
                        _ctx.OrderTrackingOrderProgressionKey.OrderShipped
                      )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_317, [
                                      _createElementVNode("div", _hoisted_318, [
                                        _createElementVNode("div", {
                                          class: "text-muted",
                                          innerHTML: 
                              _ctx.t(
                                'salesOrderOverview.orderProgressionShippedTotal',
                                item.completion
                              )
                            
                                        }, null, 8, _hoisted_319)
                                      ])
                                    ]))
                                  : (
                        item.key ===
                        _ctx.OrderTrackingOrderProgressionKey.ArticleReview
                      )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_320, [
                                        _createElementVNode("div", _hoisted_321, [
                                          _createElementVNode("div", {
                                            class: "text-muted",
                                            innerHTML: 
                              _ctx.t(
                                'salesOrderOverview.orderProgressionArticleReviewTotal',
                                item.completion
                              )
                            
                                          }, null, 8, _hoisted_322)
                                        ])
                                      ]))
                                    : (
                        item.key ===
                        _ctx.OrderTrackingOrderProgressionKey.ArticleShipped
                      )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_323, [
                                          _createElementVNode("div", _hoisted_324, [
                                            _createElementVNode("div", {
                                              class: "text-muted",
                                              innerHTML: 
                              _ctx.t(
                                'salesOrderOverview.orderProgressionArticleShippedTotal',
                                item.completion
                              )
                            
                                            }, null, 8, _hoisted_325)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]))
                }), 128))
              ])
            ])
          ])), [
            [_directive_loading, _ctx.options.scheduleLoading]
          ]),
          (_ctx.options.shipmentScheduleIsVirtual && !_ctx.isAuditView)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_326, [
                _createElementVNode("div", _hoisted_327, [
                  _createElementVNode("div", _hoisted_328, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrderOverview.shipmentSchedule")), 1),
                    _createElementVNode("span", _hoisted_329, _toDisplayString(_ctx.orderTrackingShipmentTracking[0].info.mb_fulfillment_type), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_330, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderTrackingShipmentTracking, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (index != 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_331))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_332, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tracking, (row, rowIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "timeline-item",
                            key: rowIndex
                          }, [
                            _createElementVNode("div", _hoisted_333, _toDisplayString(_ctx.customFormatDate(row.date, "MM.DD")), 1),
                            _hoisted_334,
                            _createElementVNode("div", _hoisted_335, [
                              _createElementVNode("span", _hoisted_336, _toDisplayString(_ctx.getOrderTrackingShipmentTrackingKeyMap(row.key, _ctx.t)), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.items, (it, itIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: itIndex,
                                  class: "d-flex flex-column fs-6"
                                }, [
                                  _createElementVNode("div", _hoisted_337, [
                                    _createElementVNode("div", _hoisted_338, _toDisplayString(it), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ])
                    ], 64))
                  }), 128))
                ])
              ])), [
                [_directive_loading, _ctx.options.shipmentLoading]
              ])
            : _createCommentVNode("", true),
          (!_ctx.options.shipmentScheduleIsVirtual)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_339, [
                _createElementVNode("div", _hoisted_340, [
                  _createElementVNode("div", _hoisted_341, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrderOverview.tracking")), 1),
                    _createElementVNode("span", _hoisted_342, _toDisplayString(_ctx.t("salesOrderOverview.trackingBatches", [
                  _ctx.orderTrackingShipmentTracking.length,
                ])), 1)
                  ]),
                  (!_ctx.isAuditView)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_343, [
                        _createElementVNode("button", {
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeShipmentShow && _ctx.changeShipmentShow(...args))),
                          type: "button",
                          class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                        }, [
                          _createElementVNode("span", _hoisted_344, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen024.svg" })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_345, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderTrackingShipmentTracking, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (index != 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_346))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_347, [
                        _createElementVNode("div", _hoisted_348, [
                          (0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_349, [
                                _createElementVNode("span", _hoisted_350, [
                                  (_ctx.getServiceProviderMap(item.info.courier))
                                    ? (_openBlock(), _createBlock(_component_el_image, {
                                        key: 0,
                                        class: "d-flex",
                                        fit: "contain",
                                        title: item.info.courier_show,
                                        src: _ctx.getServiceProviderMap(item.info.courier)
                                      }, null, 8, ["title", "src"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_351, [
                            _createElementVNode("div", _hoisted_352, [
                              _createElementVNode("div", _hoisted_353, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.t("salesOrderOverview.trackingBatch", [index + 1])) + " / ", 1),
                                _createElementVNode("span", null, _toDisplayString(item.info.courier_show), 1)
                              ]),
                              _createElementVNode("div", _hoisted_354, _toDisplayString(item.info.tracking_no), 1)
                            ]),
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge badge-lg fw-bold my-2", _ctx.getShipmentStatusMap(item.info.status)])
                            }, _toDisplayString(item.info.status_show), 3)
                          ])
                        ]),
                        _withDirectives(_createElementVNode("div", null, [
                          _hoisted_355,
                          _createElementVNode("div", _hoisted_356, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sku_list, (row, rowIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "fw-bold active symbol p-0",
                                key: rowIndex
                              }, [
                                _createElementVNode("span", _hoisted_357, [
                                  (row.product_gallery.length > 0)
                                    ? (_openBlock(), _createBlock(_component_el_carousel, {
                                        key: 0,
                                        class: "w-100",
                                        "indicator-position": "none",
                                        autoplay: false,
                                        arrow: "never",
                                        height: "50px"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.product_gallery, (gallery, galleryIndex) => {
                                            return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                              key: galleryIndex,
                                              class: "d-flex justify-content-center align-items-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_image, {
                                                  class: "w-100 h-100 cursor-pointer",
                                                  fit: "contain",
                                                  title: item.info.courier_show,
                                                  src: 
                                gallery.origin_url +
                                '?x-oss-process=image/resize,l_200'
                              ,
                                                  onClick: ($event: any) => (
                                _ctx.previewImages(row.product_gallery, galleryIndex)
                              )
                                                }, null, 8, ["title", "src", "onClick"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("span", _hoisted_358, _toDisplayString(row.qty), 1)
                              ]))
                            }), 128))
                          ]),
                          (item.tracking.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_359,
                                _createElementVNode("div", _hoisted_360, [
                                  _createElementVNode("div", _hoisted_361, [
                                    _hoisted_362,
                                    _createElementVNode("div", _hoisted_363, [
                                      _createElementVNode("span", _hoisted_364, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen015.svg" })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_365, [
                                      _createElementVNode("span", _hoisted_366, _toDisplayString(item.info.from_location), 1),
                                      _createElementVNode("span", _hoisted_367, _toDisplayString(_ctx.customFormatDate(item.tracking[0].date)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_368, [
                                    _hoisted_369,
                                    _createElementVNode("div", _hoisted_370, [
                                      _createElementVNode("span", _hoisted_371, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen018.svg" })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_372, [
                                      _createElementVNode("span", _hoisted_373, _toDisplayString(_ctx.t(
                                "salesOrderOverview.orderShipmentTrackingDeliverToCustomer"
                              )), 1),
                                      _createElementVNode("span", _hoisted_374, _toDisplayString(_ctx.customFormatDate(
                                item.tracking[item.tracking.length - 1].date
                              )), 1)
                                    ])
                                  ])
                                ])
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 512), [
                          [_vShow, _ctx.options.shipmentShowDetails]
                        ])
                      ])
                    ], 64))
                  }), 128))
                ])
              ])), [
                [_directive_loading, _ctx.options.shipmentLoading]
              ])
            : _createCommentVNode("", true),
          (0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_375, [
                _createElementVNode("div", _hoisted_376, [
                  _hoisted_377,
                  _createElementVNode("div", _hoisted_378, [
                    _createElementVNode("span", _hoisted_379, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen023.svg" })
                    ])
                  ])
                ]),
                _hoisted_380
              ]))
            : _createCommentVNode("", true),
          (0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_381, [
                _createElementVNode("div", _hoisted_382, [
                  _hoisted_383,
                  _createElementVNode("div", _hoisted_384, [
                    _createElementVNode("button", _hoisted_385, [
                      _createElementVNode("span", _hoisted_386, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen024.svg" })
                      ])
                    ]),
                    _hoisted_387
                  ])
                ]),
                _createElementVNode("div", _hoisted_388, [
                  _createElementVNode("div", _hoisted_389, [
                    _createElementVNode("span", _hoisted_390, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/abstract/abs027.svg" })
                    ]),
                    _hoisted_391,
                    _hoisted_392
                  ]),
                  _createElementVNode("div", _hoisted_393, [
                    _createElementVNode("span", _hoisted_394, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/abstract/abs027.svg" })
                    ]),
                    _hoisted_395,
                    _hoisted_396
                  ]),
                  _createElementVNode("div", _hoisted_397, [
                    _createElementVNode("span", _hoisted_398, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/abstract/abs027.svg" })
                    ]),
                    _hoisted_399,
                    _hoisted_400
                  ]),
                  _createElementVNode("div", _hoisted_401, [
                    _createElementVNode("span", _hoisted_402, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/abstract/abs027.svg" })
                    ]),
                    _hoisted_403,
                    _hoisted_404
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_FsLightbox, {
      toggler: _ctx.options.toggler,
      sources: _ctx.options.sources,
      slide: _ctx.options.sourcesSlide
    }, null, 8, ["toggler", "sources", "slide"])
  ], 64))
}